import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCustomerEmployeeData(selectedCompanyId?: number) {
    const { data: customerEmployees, isPlaceholderData: isPlaceholderDataCustomerEmployees } =
        useQuery({
            queryKey: [QueryKey.CUSTOMER_EMPLOYEES, selectedCompanyId],
            queryFn: async () => {
                const { data } = await axios.get(route('v2.salary.employees.for-current-company'));
                return data;
            },
            placeholderData: [],
            enabled: !!selectedCompanyId,
        });

    return {
        customerEmployees,
        isPlaceholderDataCustomerEmployees,
    };
}
